(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ipmConstants'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('download-adhoc-testing', {
            parent: 'app',
            url: '/download-adhoc-testing',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.entities.adhocTesting'
            },
            views: {
                'content@': {
                    templateUrl: 'app/download-adhoc-testing/download-adhoc-testing.html',
                    controller: 'DownloadAdhocTestingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('adhoc-testing');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                tests: ['Test', function (Test) {
                    return Test.getAllActiveAdhocTests();
                }],
            }
        });
    }

})();
